import {
  CustomFieldDefFormDefaultValues,
  CustomFieldDefFormProps,
  CustomFieldDefFormRawValues,
  CustomFieldDefFormType,
  CustomFieldDefFormValues
} from "./CustomFieldDefForm";
import {useTranslation} from "react-i18next";
import {createFormContext} from "@mantine/form";
import {customFieldDefDataType, CustomFieldDefEntity, getObjectId,} from "@ots-frontend/ots-data";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";

export const toFormDefaultsFromCustomFieldDef = (def: CustomFieldDefEntity | undefined): Partial<CustomFieldDefFormValues> => {
  return {
    company: def?.companyId,
    objectType: def?.forObjectType,
    code: def?.code,
    dataType: def?.dataType,
    required: def?.required,
    label: def?.label,
  };
};

const getInitialValues = (defaultValues: CustomFieldDefFormDefaultValues | undefined): CustomFieldDefFormRawValues => {
  return {
    company: getObjectId(defaultValues?.company),
    objectType: defaultValues?.objectType,
    code: defaultValues?.code,
    dataType: defaultValues?.dataType?.code,
    required: defaultValues?.required,
    label: defaultValues?.label,
  }
}

export const [CustomFieldDefFormProvider, useCustomFieldDefFormContext, useSharedCustomFieldDefForm] = createFormContext<CustomFieldDefFormRawValues>();

export type UseCustomFieldDefFormProps = Pick<CustomFieldDefFormProps, 'defaultValues'> & {}

export function useCustomFieldDefForm(props: UseCustomFieldDefFormProps): CustomFieldDefFormType {
  const {
    defaultValues
  } = props

  const {companyId} = useAuth()
  const {t} = useTranslation(["common"])

  const form = useSharedCustomFieldDefForm({
    initialValues: getInitialValues({
      ...defaultValues,
      company: defaultValues?.company ?? companyId,
    }),
    validate: {
      company: (value) => value ? undefined : t("common.validation.required", "Required"),
      objectType: (value) => value ? undefined : t("common.validation.required", "Required"),
      code: (value) => value ? undefined : t("common.validation.required", "Required"),
      dataType: (value) => value ? undefined : t("common.validation.required", "Required"),
      label: (value) => value ? undefined : t("common.validation.required", "Required"),
      refObjectType: (value, values) => {
        if (values.dataType === customFieldDefDataType.ref.code && !value) {
          return t("common.validation.required", "Required")
        }
        return undefined
      }
    },
  })

  return form
}
